import { render, staticRenderFns } from "./DFGuideText.vue?vue&type=template&id=28c4118d&"
import script from "./DFGuideText.vue?vue&type=script&lang=js&"
export * from "./DFGuideText.vue?vue&type=script&lang=js&"
import style0 from "./DFGuideText.vue?vue&type=style&index=0&id=28c4118d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports